import { AbstractMetaTag } from './AbstractMetaTag';

export class OpenGraphMetaTag extends AbstractMetaTag {
    constructor(property: string, content: string) {
        super('property', property, content);
    }
}
